import React, { useCallback } from 'react';
import classes from './style.module.scss';
import Button from 'app/common/Button/index';
import useTranslation from 'app/hooks/useTranslation';
import useForm from "~/app/modules/form/useForm";
import { APIResponse } from "~/types";
import { useStoreActions, useStoreState } from "~/store";
import { toast } from "react-toastify";
import { notify } from '~/app/helpers/notify';
import { TRAINING_STATUS, TrainingApprovalPayload } from '~/training/types';

export interface FooterProps {
  onClose: () => void
}

export type FooterComponent = React.FC<FooterProps>;

const Footer: FooterComponent = ({ onClose }) => {
  const { t: tAction } = useTranslation('common.confirmActions');
  const { t } = useTranslation('training');
  const { values: formValues, formEvents: { onSubmit } } = useForm<TrainingApprovalPayload>({ formName: 'approveTraining' });
  const trainingId = useStoreState(state => state.training.data.id);
  const updateTrainingAction = useStoreActions(actions => actions.training.updateTraining);
  const fetching = useStoreState(state => state.training.fetching);
  const fetchTrainingAction = useStoreActions(action => action.training.fetchTraining);
  const setNotificationAction = useStoreActions(action => action.notification.setNotifications);

  const saveClickHandler = useCallback((): void => {
    onSubmit(({ formState: { invalid } }) => {
      if (invalid) {
        toast.error(t('requiredAll'));
        return;
      }

      const { comment, status } = formValues;

      updateTrainingAction({
        id: trainingId,
        mode: 'status',
        status: status as TRAINING_STATUS,
        comment: comment as string
      }).then(async (data: APIResponse) => {
        onClose();
        if (!!data.success) {
          notify(status === 2 ? t('approveMessage') : t('rejectMessage'), 'success');
        } else {
          notify(t(`error.${data?.msg}`), 'error');
        }
        setNotificationAction([]);
        if (trainingId) {
          fetchTrainingAction(trainingId);
        }
      });
    })();
  }, [fetchTrainingAction, formValues, setNotificationAction, onSubmit, updateTrainingAction, onClose, t, trainingId]);

  return (
    <div className={`${classes['footer']}`}>
      <Button
        className={classes['abort']}
        onClick={onClose}>{tAction('cancel')}</Button>
      <Button
        className={classes['submit']}
        loading={fetching}
        onClick={saveClickHandler}>{tAction('confirm')}</Button>
    </div>
  );
};

export default Footer
